// API service para conectar com o backend Python
const DEFAULT_API_URL = 'http://172.16.10.45:5040';
const API_BASE_URL = DEFAULT_API_URL;
//const API_BASE_URL = process.env.REACT_APP_API_URL || DEFAULT_API_URL;


// Função auxiliar para fazer requisições
const apiRequest = async (endpoint, options = {}) => {
  try {
    // Obter token do localStorage
    console.log(DEFAULT_API_URL);
    const token = localStorage.getItem('authToken');
    
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };
    
    // Adicionar token de autorização se disponível
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers,
      ...options,
    });

    // Se receber 401 ou 403, limpar token e redirecionar para login
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      localStorage.removeItem('userName');
      window.location.reload(); // Recarregar página para mostrar login
      throw new Error('Token expirado ou inválido');
    }

    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;
      try {
        const errorData = await response.json();
        if (errorData.detail) {
          errorMessage = errorData.detail;
        }
      } catch (e) {
        // Se não conseguir fazer parse do JSON, usar mensagem padrão
      }
      throw new Error(errorMessage);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

// Serviços da API
export const apiService = {
  // Busca todos os colaboradores
  getColaboradores: async () => {
    try {
      return await apiRequest('/colaboradores');
    } catch (error) {
      throw error;
    }
  },

  // Busca todas as licenças e equipamentos
  getLicencas: async () => {
    return await apiRequest('/licencas');
  },

  // Métodos para compatibilidade com o formulário (dados do banco)
  getSetores: async () => {
    try {
      const colaboradores = await apiService.getColaboradores();
      
      if (!colaboradores || !colaboradores.data) {
        return [];
      }
      
      const setoresUnicos = [...new Set(colaboradores.data.map(c => c.Nome_Setor))];
      const setoresOrdenados = setoresUnicos.sort((a, b) => a.localeCompare(b, 'pt-BR'));
      
      return setoresOrdenados.map((setor, index) => ({
        id: index + 1,
        nome: setor
      }));
    } catch (error) {
      // Fallback para setores fixos em caso de erro
      return [
        { id: 1, nome: 'TI' },
        { id: 2, nome: 'RH' },
        { id: 3, nome: 'FINANCEIRO' },
        { id: 4, nome: 'COMERCIAL' },
        { id: 5, nome: 'OPERACIONAL' },
        { id: 6, nome: 'ADMINISTRATIVO' },
        { id: 7, nome: 'CONTROLADORIA' },
        { id: 8, nome: 'LOGISTICA' }
      ];
    }
  },

  getGestores: async (setorNome) => {
    try {
      const colaboradores = await apiService.getColaboradores();
      
      if (!colaboradores || !colaboradores.data) {
        return [{ id: 1, nome_completo: 'Gestor Padrão' }];
      }
      
      const gestoresDoSetor = colaboradores.data.filter(c => {
        const isSetorCorreto = c.Nome_Setor === setorNome;
        const temOrcamento = c.orcamento === 'true';
        return isSetorCorreto && temOrcamento;
      });
      
      const result = gestoresDoSetor.map((gestor, index) => ({
        id: index + 1,
        nome_completo: gestor.Nome
      }));
      
      // Se não encontrar gestores, retornar gestor padrão
      if (result.length === 0) {
        return [{ id: 1, nome_completo: 'Gestor Padrão' }];
      }
      
      return result;
    } catch (error) {
      return [{ id: 1, nome_completo: 'Gestor Padrão' }];
    }
  },

  getFuncionarios: async (setorId) => {
    // Retorna funcionários baseados no setor selecionado
    const colaboradores = await apiService.getColaboradores();
    const setores = await apiService.getSetores();
    const setorNome = setores.find(s => s.id === setorId)?.nome;
    
    if (!setorNome) return [];
    
    const funcionariosDoSetor = colaboradores.data
      .filter(c => c.Nome_Setor === setorNome)
      .sort((a, b) => a.Nome.localeCompare(b.Nome, 'pt-BR')); // Ordenar por nome
    
    // Obter cargos únicos do setor para mapear corretamente os IDs
    const cargosUnicos = [...new Set(
      colaboradores.data
        .filter(c => c.Nome_Setor === setorNome)
        .map(c => c.Nome_Cargo)
    )].sort((a, b) => a.localeCompare(b, 'pt-BR'));
    
    return funcionariosDoSetor.map((colaborador, index) => {
      const cargoIndex = cargosUnicos.indexOf(colaborador.Nome_Cargo);
      return {
        id: index + 1,
        nome_completo: colaborador.Nome,
        cargo: {
          id: cargoIndex + 1, // ID correto baseado na posição na lista de cargos únicos
          nome: colaborador.Nome_Cargo
        },
        centro_de_custo: colaborador.Nome_Centro_Custo
      };
    });
  },

  getCargos: async (setorId) => {
    // Retorna cargos baseados no setor selecionado
    const colaboradores = await apiService.getColaboradores();
    const setores = await apiService.getSetores();
    const setorNome = setores.find(s => s.id === setorId)?.nome;
    
    if (!setorNome) return [];
    
    const cargosUnicos = [...new Set(
      colaboradores.data
        .filter(c => c.Nome_Setor === setorNome)
        .map(c => c.Nome_Cargo)
    )];
    
    // Ordenar alfabeticamente
    const cargosOrdenados = cargosUnicos.sort((a, b) => a.localeCompare(b, 'pt-BR'));
    
    return cargosOrdenados.map((cargo, index) => ({
      id: index + 1,
      nome: cargo
    }));
  },

  getItensSolicitaveis: async () => {
    // Retorna licenças e equipamentos
    const licencas = await apiService.getLicencas();
    const itensOrdenados = licencas.data.sort((a, b) => a.Nome.localeCompare(b.Nome, 'pt-BR'));
    const itensMapeados = itensOrdenados.map((item, index) => ({
      id: index + 1,
      nome: item.Nome,
      tipo: item.Tipo,
      preco: parseFloat(item.Preco),
      descricao: item.Descricao || ''
    }));
    
    return itensMapeados;
  },

  getProximoNumeroQLP: async (setorNome) => {
    try {
      const data = await apiRequest(`/qlp/proximo-numero/${encodeURIComponent(setorNome)}`);
      return data.data;
    } catch (error) {
      // Fallback sequencial baseado no setor
      return {
        proximo_numero: 1,
        setor: setorNome,
        qlps_existentes: 0
      };
    }
  },

  // Função para criar relatório
  createRelatorio: async (relatorioData) => {
    try {
      // Usar apiRequest que adiciona o token automaticamente
      return await apiRequest('/relatorios', {
        method: 'POST',
        body: JSON.stringify(relatorioData),
      });
    } catch (error) {
      throw error;
    }
  },

  // Funções para projetos
  createProjeto: async (projetoData) => {
    try {
      return await apiRequest('/projetos', {
        method: 'POST',
        body: JSON.stringify(projetoData),
      });
    } catch (error) {
      throw error;
    }
  },

  getProjetos: async () => {
    try {
      return await apiRequest('/projetos');
    } catch (error) {
      throw error;
    }
  },

  getProjeto: async (projetoId) => {
    try {
      return await apiRequest(`/projetos/${projetoId}`);
    } catch (error) {
      throw error;
    }
  },

  getProjetoRelatorio: async (identificadorUnico) => {
    try {
      return await apiRequest(`/projetos/${identificadorUnico}`);
    } catch (error) {
      throw error;
    }
  },

  getProjetosSolicitacoes: async (filtros = {}) => {
    try {
      // Construir query string com filtros (só enviar filtros não vazios)
      const params = new URLSearchParams();
      if (filtros.pesquisa && filtros.pesquisa.trim()) {
        params.append('pesquisa', filtros.pesquisa.trim());
      }
      if (filtros.setor && filtros.setor.trim()) {
        params.append('setor', filtros.setor.trim());
      }
      if (filtros.gestor && filtros.gestor.trim()) {
        params.append('gestor', filtros.gestor.trim());
      }
      
      const queryString = params.toString();
      const url = queryString ? `/projetos/solicitacoes?${queryString}` : '/projetos/solicitacoes';
      
      return await apiRequest(url);
    } catch (error) {
      throw error;
    }
  },

  verificarWhitelist: async () => {
    try {
      // Usar endpoint específico para verificar whitelist (mais eficiente)
      const response = await apiRequest('/auth/verificar-whitelist');
      return response.in_whitelist === true;
    } catch (error) {
      // Se der qualquer erro, assume que não está na whitelist
      return false;
    }
  }
};

export default apiService;

